
import Vue from 'vue'
import common from '../libs/common.mixin'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Msg from 'vux/src/components/msg/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'


export default {
mixins:[common],
components: {
XInput,
Group,
XButton,
Cell,
Msg,
Flexbox,
FlexboxItem
},
data () {
return {
TEXT_VCODE:'发送验证码',
VCODE_LIMIT_SECONDS:0,
vcode_sending:false,
register:{
account:'',
vcode:'',
password:'',
repassword: ''
},
error:''
}
},
computed:{
isMobileValid(){
let mreg = /^1[\d]{10}$/
return mreg.test(this.register.account)
},
isFormValid(){
let valid = true
let ereg = /^\s*$/
let mreg = /^1[\d]{10}$/
for(let key in this.login){
let value = this.login[key]
if(key == 'account'){
if(!mreg.test(value)){
valid = false
break;
}
}else{
if(ereg.test(value)){
valid = false
break;
}
}
}
return valid
},
vcode_text(){
if(this.VCODE_LIMIT_SECONDS > 0){
return this.VCODE_LIMIT_SECONDS + '秒'
}
return this.TEXT_VCODE
}
},
methods:{
send_vcode(){
let params = {type:'signup'}
params.mobile = this.register.account
this.vcode_sending = true
this.$http.post('open/vcode',params)
.then(response=>{
this.clear_error()
this.VCODE_LIMIT_SECONDS = 120
this.loop_check_vcode()
},response=>{
this.error_tip(response.body.message)
this.vcode_sending = false
})
},
loop_check_vcode(){
this.VCODE_LIMIT_SECONDS--
if(this.VCODE_LIMIT_SECONDS <= 0){
this.VCODE_LIMIT_SECONDS = 0
this.vcode_sending = false
return
}
setTimeout(()=>{
this.loop_check_vcode()
},1000)
},
registerOk(){
this.$router.replace('/index')
},
registerOkBack(){

this.page('index')
},
check () {
if(this.register.password != this.register.repassword){
this.error_tip('两次密码不一致')
return false
}
return true
},
doRegister(){
if(this.check()){
this.clear_error()
this.$http.post('signup',this.register)
.then(response=>{
this.clear_error()
this.success('注册成功',
'您的账号已经注册成功,您可以凭手机号登录系统',
this.registerOk.bind(this),
this.registerOkBack.bind(this)
)

},response=>{
this.error_tip(response.body.message)
})
}



}
}
}



// WEBPACK FOOTER //
// ./src/views/register.vue